import { userInfoFrag } from '../../../../utils/type/user.common-type';
import { personInfoFrag } from '../../../../utils/type/person.common-type';

export const getWorkDetailFrag = `
    id
    workType
    serviceId
    personId
    folderId
    dateFrom
    users {
        ${userInfoFrag}
    }
    tags
    workData {
        ... on WorkDataContinuousRecordObject {
            data
            form
            presence
        }
    }
    person {
        ${personInfoFrag}
    }
    offers {
        offerId
        applications
        operations
        procedures
        serviceOffer {
            code
            name
            color
        }
    }
`;
